import React from "react";
import PropTypes from "prop-types";
const SolidLineIcon = ({
  noPointer,
  className,
  width,
  size,
  height,
  style,
  color,
  title
}) => (
  <svg
    className={className}
    style={style}
    data-no-pointer={noPointer}
    width={width || size || 20}
    height={height || size || 20}
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby="title"
  >
    <title>{title}</title>
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h20v20H0z" />
      <rect
        stroke={color || "var(--color-easil-gray-x-dark)"}
        fill={color || "var(--color-easil-gray-x-dark)"}
        x="3.5"
        y="9.5"
        width="13"
        height="1"
        rx=".5"
      />
    </g>
  </svg>
);
SolidLineIcon.propTypes = {
  className: PropTypes.string,
  width: PropTypes.string,
  size: PropTypes.string,
  height: PropTypes.string,
  style: PropTypes.object,
  color: PropTypes.string
};

export default SolidLineIcon;
